import { Link, darken } from "@mui/material";

export function trackScrollProgress(element: Node) {
  let isFinished = false;
  const onScrollEnd = () => (isFinished = true);
  const onScrollStart = () => (isFinished = false);
  element.addEventListener("scrollstart", onScrollStart);
  element.addEventListener("scrollend", onScrollEnd);
  return new Promise((resolve) => {
    function trackScroll() {
      if (isFinished) {
        element.removeEventListener("scrollstart", onScrollStart);
        element.removeEventListener("scrollend", onScrollEnd);
        return resolve(isFinished);
      }
      requestAnimationFrame(trackScroll);
    }
    requestAnimationFrame(trackScroll);
  });
}

export async function scrollDomElementIntoView(
  element: HTMLElement | Element | null,
  scrollContainer: HTMLElement | Element | null,
  options?: ScrollIntoViewOptions
) {
  const defaultOptions: ScrollIntoViewOptions = {
    behavior: "smooth",
    block: "center",
  };
  if (!element || !scrollContainer) return;
  element?.scrollIntoView(options || defaultOptions);
  return trackScrollProgress(scrollContainer);
}

export function createJsxLink(
  text: string,
  href: string,
  config?: {
    target: string;
  }
) {
  const baseColor = "#3d5afe";

  return (
    <Link
      href={href}
      target={config?.target || "_blank"}
      sx={{
        color: darken(baseColor, 0.3),
        fontWeight: "500",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        position: "relative",
        textDecoration: "none",
        "&:hover": {
          color: baseColor,
          textDecoration: "underline",
          textUnderlineOffset: "2px",
        },
      }}
    >
      {text}
    </Link>
  );
}
